import { fromJS } from 'immutable'

import _last from 'lodash/last'
import _includes from 'lodash/includes'

import { LOCATION_CHANGE } from 'react-router-redux'

import {
  CHANGE_VEHICLE,
  CHANGE_USER,
  CHANGE_POLICY,
  CHANGE_DOCUMENTS,
  CHANGE_CLAIM
} from './constants'


export const initialState = fromJS({
  vehicle: {},
  policy: {},
  documents: [],
  user : {},
  claim: {}
})


export default function reducer(state = initialState, action) {
  switch(action.type){
    case CHANGE_VEHICLE:
      return state.set('vehicle', fromJS(action.vehicle))
    case CHANGE_USER:
      return state.set('user', fromJS(action.user))
    case CHANGE_POLICY:
      return state.set('policy', fromJS(action.policy))
    case CHANGE_DOCUMENTS:
      return state.set('documents', action.documents)
    case CHANGE_CLAIM:
      return state.set('claim', action.claim)
    case LOCATION_CHANGE:
      // every time we click on a tab LOCATION_CHANGE is triggered
      // but we aren't leaving this scene so we need to avoid resetting state
      // if we didn't change scene
      const tabNames = ['siniestro', 'detalle', 'poliza', 'conductores', 'datossiniestro']
      const payloadSplit = action.payload.pathname.split('/')
      const tab = _last(payloadSplit)
      // console.log('-->Reducer: ' + tab)
      const isTab = _includes(tabNames, tab)
      if (isTab)  {
        return state
      } else {
        const payloadCount = payloadSplit.length
        if (payloadCount > 1) {
          const last = payloadSplit[payloadCount-2]
          if (_includes(tabNames, last)) {
            return state
          }
        }
      }
      return initialState  
      // return isTab ? state : initialState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/reducer.js